require('./KeysSendView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ actions
const UserData = require('actions/contactCenter/userData');
const CodeOTP = require('actions/contactCenter/codeOtp');
const profileActions = require('actions/profile');
const recoveryKeys = require('actions/contactCenter/recoveryKeys');
const KeysSendView = require('components/myProfile/KeysCCSteps/KeysSendView');
const myGlobalPositionActions = require('actions/myGlobalPosition');

class KeysSendViewContainer extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const { requestPublicInformation, history } = this.props;
        this.props.requestPublicInformation = (originCountryDefault) => requestPublicInformation(originCountryDefault, history);

        return (
            <KeysSendView {...this.props} />
        );
    }
}

KeysSendViewContainer.propTypes = {
    immUserData: PropTypes.object,
    immCodeOTPData: PropTypes.object,
    immKeysData: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestcodeOTP: PropTypes.func,
    requestSendKey: PropTypes.func,
    requestPhoneOTP: PropTypes.func,
    requestcodeOTPReset: PropTypes.func,
    requestSendKeyReset: PropTypes.func,
    requestGetProfile: PropTypes.func,
    requestResetError: PropTypes.func,
    requestStepSuccess: PropTypes.func,
    setVisibleStep: PropTypes.func,
    requestPublicInformation: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.KeysSendViewContainer = withRouter(connect(state => ({
    immUserData: state.userData,
    immCodeOTPData: state.codeOtp,
    immKeysData: state.recoveryKeys,
    immProfileFields: state.profile,
    immSignaturePattern: state.signaturePattern,
    immPrinter: state.printer
}), {
    requestPhoneOTP: UserData.setPhoneOTP,
    requestcodeOTP: CodeOTP.sendPhoneOTP,
    requestSendKey: recoveryKeys.sendKey,
    requestcodeOTPReset: CodeOTP.CodeOTPDataReset,
    requestResetError: CodeOTP.ResetError,
    requestStepSuccess: CodeOTP.requestStepSuccess,
    requestSendKeyReset: recoveryKeys.KeyDataReset,
    setVisibleStep: recoveryKeys.setWizardVisibleStep,
    validateSignaturePattern: recoveryKeys.validatePatternSignature,
    requestProfile: profileActions.requestProfile,
    requestPublicInformation: myGlobalPositionActions.requestPublicInformation,
})(KeysSendViewContainer));
